import styled from "@emotion/styled"

const ArticleCTAIcon = styled.div`
  width: 540px;
  height: 540px;
  position: absolute;

  z-index: 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    top: 20%;
    right: -50%;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    top: 30%;
    right: 0;
  }

  > svg {
    width: 100%;
    object-fit: cover;

    > g {
      > path {
        opacity: 0.1;
        fill: #fff;
      }
    }

    > path {
      opacity: 0.1;
      fill: #fff;
    }
  }
`

export default ArticleCTAIcon
